import {
  AssignmentRenewHistoryModel,
  RenewActionEnum,
  RenewAssignmentEnum,
  RenewKindEnum,
} from 'api/adminApiClient';

type ActionLabels = {
  [key in RenewActionEnum]: {
    [kind in RenewKindEnum]?:
      | {
          [type in RenewAssignmentEnum]?: string;
        }
      | string;
  };
};

const actionLabels: ActionLabels = {
  [RenewActionEnum.Submited]: {
    [RenewKindEnum.Rehire]: {
      [RenewAssignmentEnum.WithoutChanges]:
        'submitted a rehire without changes',
      [RenewAssignmentEnum.WithChanges]:
        'submitted a rehire with changes at the same Customer',
      [RenewAssignmentEnum.WithChangeCustomer]:
        'submitted a rehire at a new Customer',
    },
    [RenewKindEnum.Renew]: {
      [RenewAssignmentEnum.WithoutChanges]:
        'submitted a renewal without changes',
      [RenewAssignmentEnum.WithChanges]: 'submitted a renewal with changes',
    },
  },
  [RenewActionEnum.Approved]: {
    [RenewKindEnum.Rehire]: 'approved the rehire request',
    [RenewKindEnum.Renew]: 'approved the renewal request',
  },
};

const getSubmittedLabel = (
  data: AssignmentRenewHistoryModel,
): string | undefined => {
  if (data.renewKind === undefined || data.renewType === undefined) {
    return undefined;
  }

  const renewKind =
    data.renewKind as keyof (typeof actionLabels)[RenewActionEnum.Submited];
  const renewType = data.renewType as RenewAssignmentEnum;

  const submittedLabels = actionLabels[RenewActionEnum.Submited]?.[
    renewKind
  ] as
    | {
        [key in RenewAssignmentEnum]?: string;
      }
    | undefined;

  return submittedLabels?.[renewType];
};

const getApprovedLabel = (
  data: AssignmentRenewHistoryModel,
): string | undefined => {
  if (data.renewKind === undefined) {
    return undefined;
  }

  const renewKind =
    data.renewKind as keyof (typeof actionLabels)[RenewActionEnum.Approved];

  return actionLabels[RenewActionEnum.Approved]?.[renewKind] as
    | string
    | undefined;
};

const getHistoryRenewalRehireLabel = (
  data: AssignmentRenewHistoryModel,
): string | undefined => {
  if (data.action === RenewActionEnum.Submited) {
    return getSubmittedLabel(data);
  }

  if (data.action === RenewActionEnum.Approved) {
    return getApprovedLabel(data);
  }

  return undefined;
};

export { getHistoryRenewalRehireLabel };
